import { createRouter, createWebHistory } from "vue-router";
import { store } from "@/store/index";

// 레이아웃 컴포넌트 import
import MainLayout from "@/layouts/MainLayout.vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import PopupLayout from "@/layouts/PopupLayout.vue";
import MobileLayout from "@/layouts/MobileLayout.vue";

const routes = [
  // root redirect
  {
      path: "/", // 기본 경로 /
      redirect: "/niceTaxMain.do" // /로 접근하면 /niceTaxMain.do로 리다이렉트
  },
  // 메인
  {
    path: "/", // 기본 경로 /
    component: MainLayout,
    children: [
      { // 메인
        path: "/niceTaxMain.do",
        component: () => import("@/views/NiceTaxMainPage.vue"),
      },
      { // 자료전송메인
        path: "/niceTaxSendMain.do",
        component: () => import("@/views/send/NiceTaxSendMainPage.vue"),
      },
    ],
  },

  {
    path: "/", // 기본 경로 /
    component: DefaultLayout,
    children: [
      { // 사용자가이드
        path: "/niceTaxUserGuide.do",
        component: () => import("@/views/guide/NiceTaxUserGuidePage.vue"),
      },
      { // 자료수집동의
        path: "/niceTaxAgree.do",
        component: () => import("@/views/send/NiceTaxAgreePage.vue"),
      },
      { // 사업자번호로그인
        path: "/niceTaxLoginPrincipal.do/:nextUrl?",
        name: "principalLogin",
        component: () => import("@/views/login/NiceTaxLoginPrincipalPage.vue"),
        props: (route) => ({ nextUrl: route.params.nextUrl }),

      },
      { // 세무대리인 로그인
        path: "/niceTaxLoginAgent.do/:nextUrl?",
        name: "agentLogin",
        component: () => import("@/views/login/NiceTaxLoginAgentPage.vue"),
        props: (route) => ({ nextUrl: route.params.nextUrl }),
      },
      { // 서버형 인증서 로그인
        path: "/niceTaxLoginCert.do/:nextUrl?",
        name: "certLogin",
        component: () => import("@/views/login/NiceTaxLoginCertPage.vue"),
        props: (route) => ({ nextUrl: route.params.nextUrl }),
      },
      { // 공동인증서 관리
        path: "/niceTaxCertInfo.do",
        component: () => import("@/components/cert/CertInfoPage.vue"),
      },
      { // 전송대상 정보 입력
        path: "/niceTaxInputPrincipal.do",
        component: () => import("@/views/send/NiceTaxInputPrincipalPage.vue"),
        meta: { authRequired: true },
      },
      { // 전송대상 정보 입력(세무대리인)
        path: "/niceTaxInputAgent.do",
        component: () => import("@/views/send/NiceTaxInputAgentPage.vue"),
        meta: { authRequired: true },
      },
      { // 세무증명서 제출기관 선택 
        path: "/niceTaxInstitution.do",
        component: () => import("@/views/send/NiceTaxInstitutionPage.vue"),
        meta: { authRequired: true },
      },
      { // 전송자료 선택 및 전송
        path: "/niceTaxSend.do",
        component: () => import("@/views/send/NiceTaxSendPage.vue"),
        meta: { authRequired: true },
      },
      { // 전송 결과 확인
        path: "/niceTaxSendCheck.do",
        component: () => import("@/views/send/NiceTaxSendCheckPage.vue"),
        meta: { authRequired: true },
      },
      { // 자료전송내역 조회
        path: "/niceTaxList.do",
        component: () => import("@/views/send/NiceTaxSendListPage.vue"),
        meta: { authRequired: true },
      },
    ],
  },

  // 간편인증
  {
    path: "/", // 기본 경로 /
    component: MobileLayout,
    children: [
      { // 간편인증 메인
        path: "/niceTaxPsnMain.do",
        component: () => import("@/views/psn/NicecTaxPsnMainPage.vue"),
      },
      { // 간편인증 전송결과 확인
        path: "/niceTaxPsnSendCheck.do",
        component: () => import("@/views/psn/NiceTaxPsnSendCheckPage.vue"),
      },
    ],
  },

  // 팝업
  {
    path: "/", // 기본 경로 /
    component: PopupLayout,
    children: [],
  },

  // 예외
  {
    path: "/404_jsp",
    name: "404",
    component: () => import("@/views/common/404.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404_jsp", // 잘못된 경로에 대한 리다이렉션
  },
];

const router = createRouter({
  mode: "history",
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 뒤로가기 버튼 눌렀을 때는 이전 위치 유지
    if (savedPosition) {
      return savedPosition;
    }
    // 그 외에는 무조건 최상단으로
    return { top: 0 };
  },
});

// 이전 경로 저장 
let previousRoute = null;
router.beforeEach((to, from, next) => {
  previousRoute = from;
  next();
});
router.getPreviousRoute = () => {
  return previousRoute;
};

router.beforeEach(function (to, from, next) {
  const isLogin = store.getters["userStore/isLogin"];
  if (to.matched.some((routeInfo) => routeInfo.meta.authRequired)) {
    if (!isLogin) {
      alert("로그인 후 사용 하실 수 있습니다.");
      next("/");
    } else {
      next();
    }
  } else {
    next();
  }

});

export default router;
